(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["general"] = factory();
	else
		root["lib"] = root["lib"] || {}, root["lib"]["general"] = factory();
})(window, function() {
return 